<div *ngIf="show || (loader.isLoading | async)" class="loader-overlay">
  <div class="flex flex-col items-center justify-center py-20">
    <div class="relative">
      <div
        class="animate-spin rounded-full h-16 w-16 border-4 border-[#CBFBF1]"
      ></div>
      <div
        class="animate-spin rounded-full h-16 w-16 border-t-4 border-[#009689] absolute top-0 left-0"
      ></div>
    </div>
    <div class="mt-6 text-center">
      <p class="text-lg font-medium text-gray-700">{{ mainMessage }}</p>
      <p class="text-sm text-gray-500 mt-1">{{ subMessage }}</p>
    </div>
  </div>
</div>
